import _ from "lodash";
import { Output } from "valibot";

import { VariablesRecordSchema } from "shared/schemas";

// * set lodash to match any  variables in braces e.g. "hello, {name}"
const variableRegex = /@(\w+)/g;
_.templateSettings.interpolate = variableRegex;

const replaceVariablesInString = (
  initialVal: string,
  variables: Output<typeof VariablesRecordSchema>,
) => {
  if (!initialVal) {
    return "";
  } else if (Object.keys(variables).length === 0) {
    return initialVal;
  }

  const presentVariables = initialVal.match(variableRegex) || [];
  if (presentVariables.length === 0) {
    return initialVal;
  }

  const mappedVariables = Object.fromEntries(
    presentVariables.map(presentVariable => [
      presentVariable.slice(1),
      variables[presentVariable.slice(1)]?.value ||
        variables[presentVariable.slice(1)]?.fallback ||
        presentVariable,
    ]),
  );

  const compiled = _.template(initialVal);
  return compiled(mappedVariables);
};

export default replaceVariablesInString;
